/**
 * @property interval number
 * @property days number
 * @property hours number
 * @property minutes number
 * @property seconds number
 */
export default class TimerDTO {
    MILLISECONDS_TO_SECOND_BASE_MULTIPLIER = 1000;
    MILLISECONDS_TO_MINUTE_BASE_MULTIPLIER = this.MILLISECONDS_TO_SECOND_BASE_MULTIPLIER * 60;
    MILLISECONDS_TO_HOUR_BASE_MULTIPLIER = this.MILLISECONDS_TO_MINUTE_BASE_MULTIPLIER * 60;
    MILLISECONDS_TO_DAY_BASE_MULTIPLIER = this.MILLISECONDS_TO_HOUR_BASE_MULTIPLIER * 24;

    /**
     * @param string_date string
     * @param now Date
     */
    constructor(string_date, now) {
        const interval = new Date(string_date) - now;
        this.interval = interval < 0 ? 0 : interval;
        this.calculateTimeAttributes();
    }

    nextTick() {
        if (this.interval <= 0) {
            return;
        }

        this.interval -= 1000;
        this.calculateTimeAttributes();
    }

    calculateTimeAttributes() {
        if (this.interval <= 0) {
            this.days = this.hours = this.minutes = this.seconds = 0;
            return;
        }

        let diffTime = this.interval;
        this.days = this.getTimeFromMillisecondsByMultiplier(diffTime, this.MILLISECONDS_TO_DAY_BASE_MULTIPLIER);

        diffTime -= this.days * this.MILLISECONDS_TO_DAY_BASE_MULTIPLIER;
        this.hours = this.getTimeFromMillisecondsByMultiplier(diffTime, this.MILLISECONDS_TO_HOUR_BASE_MULTIPLIER);

        diffTime -= this.hours * this.MILLISECONDS_TO_HOUR_BASE_MULTIPLIER;
        this.minutes = this.getTimeFromMillisecondsByMultiplier(diffTime, this.MILLISECONDS_TO_MINUTE_BASE_MULTIPLIER);

        diffTime -= this.minutes * this.MILLISECONDS_TO_MINUTE_BASE_MULTIPLIER;
        this.seconds = this.getTimeFromMillisecondsByMultiplier(diffTime, this.MILLISECONDS_TO_SECOND_BASE_MULTIPLIER);
    }

    /**
     * @param milliseconds number
     * @param multiplier number
     * @returns {number}
     */
    getTimeFromMillisecondsByMultiplier(milliseconds, multiplier) {
        return Math.floor(milliseconds / multiplier);
    }
}
